import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PermissionCheckerService } from '../../../services/permission-checker.service';

export const permissionGuard = (requiredPermissions: string[]): CanActivateFn => {
  return () => {
    const permissionChecker = inject(PermissionCheckerService);
    const router = inject(Router);

    if (permissionChecker.hasAnyPermission(requiredPermissions)) {
      return true;
    }

    void router.navigate(['/auth/access-denied']);
    return false;
  };
};
